// extracted by mini-css-extract-plugin
export var copyright = "style-module--copyright--21ba2";
export var footer = "style-module--footer--d5b7f";
export var footerTop = "style-module--footerTop--d0274";
export var footer_logo = "style-module--footer_logo--4f629";
export var nav_item = "style-module--nav_item--38ea7";
export var nav_list = "style-module--nav_list--262d7";
export var sub_nav_list = "style-module--sub_nav_list--0afdb";